export function saveSideMenuData(data) {
    return { type: "SAVE_SIDEMENU_DATA", data: data };
}
export function saveCompanyData(data) {
    return { type: "SAVE_COMPANY_DATA", data: data };
}

export function savePaymentSettinsData(data) {
    return { type: "SAVE_PAYMENt_SETTING_DATA", data: data };
}